module.exports = __webpack_public_path__ + "static/media/heart.d5b14652.png";